import { useEffect } from 'react';



function Index(): null {

  useEffect(() => {
    window.location.replace('https://sp.aitsukinakuru.com/illuamor/');
  }, []);

  return null;
}
export default Index;